import { render } from "./IA.vue?vue&type=template&id=913e9d52"
import script from "./IA.vue?vue&type=script&lang=js"
export * from "./IA.vue?vue&type=script&lang=js"
script.render = render

export default script